import React from "react";

import { useSelector } from "react-redux";
const TRIANGLE_RED = '#F84F31';
const TRIANGLE_GREEN = '#23c552';

const Rows = ({ api, code, rowData, index, PROCode ,onOpen,dataIndex,sheetType,RevCmptCheckList}) => {

    const remark = rowData?.find((search) => {
        return search.name === "remark"
    })
    const remark_chk = remark?.value !== "FALSE";

    const checkHide = rowData?.find((search) => {
        return search.name === "hide"
    })

    let cnt = 0;
    // urs 62번, Admin 권한만 hide 된거 보여주기 (32 ~ 35번째 줄까지 추가)
    const userSelector = useSelector((store) => store.user);

    const uniqueCode = rowData.find(data=>data.name ==='uniqueCode')?.value;
    const sheetReview = RevCmptCheckList  ? RevCmptCheckList.filter(sheet => sheet.uniqueCode ===uniqueCode) : undefined;
    let revRowData = [];

    rowData.map((data,i) =>{
        const celNm = sheetReview  ? sheetReview.find(v => (data.name === "unit2" && data.revCelNm === v.celNm) || (data.name !== "unit2" && data.name === v.celNm)) : undefined;
        if(celNm){
            data =  { ...data,cmptCheck:true, cmptType:celNm.cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN} ;
        }else{
            data =  { ...data,cmptCheck:false } ;
        }
        revRowData = [...revRowData ,...[data]]
    } )


    if (checkHide?.value === "TRUE" && !userSelector.isAdmin) {
        return null
    } else {
        return (
            <>
                <tr rowSpan={remark_chk ? "2" : "1"}>
                    <td rowSpan={remark_chk ? "2" : "1"} >{index + 1}</td>

                    {revRowData.map((vv, ii) => {
                        let sndsite = "";
                        if (vv.name.match(/^snd/)) {
                            sndsite = "sndsite";
                        }

                        if (vv.type === "checkbox" ||vv.type === "hidden") {
                            return null
                        } else if(vv.type === "seperator") {
                            cnt++;
                            return (
                                <td
                                    key={index + "" + ii}
                                    className={`seperator`}
                                    style={{...vv.style, ...vv.borderStyle}}
                                >
                                {vv.value}
                            </td>
                            );
                        }else if (vv.type === "select") {
                            cnt++;
                            if (vv.options === "sample" || vv.options === "qcoption") {
                                return (
                                    <td 
                                        onClick={() =>onOpen(vv,uniqueCode)} 
                                        key={index + "" + ii} 
                                        className={`${!vv.label ? "no-text" : ""} ${sndsite}`}
                                        style={!!vv.style ? {...vv.style,cursor:"pointer", backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"} : {cursor:"pointer",backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"}}
                                    >
                                    {vv.cmptCheck ? <div style={{position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 16, height: 16, transform: "translateX(8px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                                    {vv.value}
                                    </td>
                                );
                            } else {
                                return (
                                    <td
                                        onClick={() =>onOpen(vv,uniqueCode)} 
                                        key={index + "" + ii} 
                                        className={`${!vv.value ? "no-text" : ""} ${sndsite}`}
                                        style={!!vv.style ? {...vv.style,cursor:"pointer", backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"} : {cursor:"pointer",backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"}}
                                    >
                                    {vv.cmptCheck ? <div style={{position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 16, height: 16, transform: "translateX(8px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                                    {vv.value}
                                    </td>
                                );
                            }
                        } else {
                            if( vv.name === "paraCd" )
                                return  null
                            cnt++;
                            return (
                                <td
                                    onClick={() =>onOpen(vv,uniqueCode)} 
                                    key={index + "" + ii} 
                                    className={`${!vv.value ? "no-text" : ""} ${sndsite}`}
                                    style={!!vv.borderStyle ? {...vv.borderStyle,cursor:"pointer", backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"} : {cursor:"pointer",backgroundColor: vv.active ? "#eee" : "", overflow: "hidden"}}
                                >
                                {vv.cmptCheck ? <div style={{position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 16, height: 16, transform: "translateX(8px) translateY(-7px) rotateZ(45deg)"}}></div> : ""}
                                {vv.value}
                            </td>
                            );
                        }
                    })}
                </tr>
                <tr className={(remark_chk ? "" : "d-none")}>
                <td colSpan={cnt} data-colspan={cnt} style={{ textAlign: "left",overflow: "hidden",cursor:"pointer" }}
                    onClick={() =>
                        onOpen(
                            revRowData.find((f) => f.name === "remark"),
                            uniqueCode
                        )
                    }>
                    {revRowData.find((f) => f.name === "remark")?.cmptCheck && (
                        <div style={{
                            position: "absolute",
                            backgroundColor:revRowData.find((f) => f.name === "remark")?.cmptType,
                            top: 0,
                            right: 0,
                            width: 16,
                            height: 16,
                            transform: "translateX(8px) translateY(-7px) rotateZ(45deg)"
                        }}></div>
                    )}
                    {remark?.value}
                </td>
                </tr>
            </>

        )
    }
}

export default React.memo(Rows);
